export default {
    syssetting: "/index/home.home/indexConfig",     // 系统设置
    login: "/index/user.user/login",                // 用戶登錄
    register: "/index/user.user/register",          // 用戶注冊
    usersetReal: "/index/user.user/usersetReal",    // 认证
    userseller: "/index/user.user/register_seller", // 店铺信息
    getusr: "/index/user.user/memberInfo",          // 获取会员
    editusr: "/index/user.user/updateProfile",      // 编辑用户
    setpaypwd: "/index/user.user/changePayPassword",// 设置支付密码
    myWallet: '/index/user.user/myWalletList',      // 获取我的钱包列表
    bindUserBank:'/index/user.user/bindUserBank',   // 绑定钱包/收款方式
    check: '/index/shop.shop/check',                // 检查用户
    openseller: '/index/shop.shop/createShop',

    getShopInfo: "/index/shop.shop/getShopInfo",    // 获取店铺信息 shop_id
    getproduct: "/index/product.product/getShopProductList",    //获取门店商品列表


    addShopProduct: '/index/product.product/addShopProduct',    // 新增商品
    getProductDetail: '/index/product.product/getProductDetail',// 商品详情
    editShopProduct: '/index/product.product/editShopProduct',  // 商品编辑
    deleteShopProduct: '/index/product.product/deleteShopProduct',//商品删除

    billSummary: '/index/user.user/billSummary',        // 获取资金统计
    deposit: '/index/user.user/deposit',                // 申请提现
    stream: '/index/user.user/stream',                  // 资产明显

    getHomeProductList: '/index/product.product/getHomeProductList',    //首页商品
    homeBanner: '/index/home.home/getBannerList',          // 首页Banner
    getContentIndex: '/index/home.home/getContentIndex',    // 内容中心首页
    auctionrule: '/index/home.home/getAuctionValue'         // 拍卖规则
}
